import { render, staticRenderFns } from "./ComparisonTable.vue?vue&type=template&id=4b1b093f&scoped=true"
import script from "./ComparisonTable.vue?vue&type=script&lang=js"
export * from "./ComparisonTable.vue?vue&type=script&lang=js"
import style0 from "./ComparisonTable.vue?vue&type=style&index=0&id=4b1b093f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1b093f",
  null
  
)

export default component.exports